import { defineStore } from 'pinia';
import axios from 'axios';
import { getStates } from '../resources/js/api/lobbying';

export const useFeedStore = defineStore('feed', {
  state: () => {
    return {
      sidebarCategory: 'home',
      usStates: [],
    };
  },
  actions: {
    updateSidebarCategoty(newValue) {
      this.sidebarCategory = newValue;
    },
    getStatesFromStore() {
      getStates()
        .then(response => {
          this.usStates = response.states;
        })
        .catch(error => {
          console.warn(error);
        });
    },
  },
});
